export default __webpack_public_path__ + "static/media/EnlightenmentNow.a7a8d3a1.png";